<template>
   
    <div class="home">
        <div class="main-option">
            <h1>Credits</h1>
            - <a href="https://anthonychu.ca/" target="_blank">Anthony Chu</a><br />
            - Maximilian Melcher<br />
            - Nicola Moresi


        </div>

        <div class="footer">
            <img style="width: 24%; margin-left: 18px; float:left" alt="Digitalswitzerland" src="@/assets/digitalSwitzerland.png" />
            <img style="width: 18%; margin: 0 auto " alt="Microsoft" src="@/assets/microsoft-logo-png-transparent-20.png" />

            <img style="width: 16%; float: right; margin-right: 25px;" alt="Moresi.com" src="@/assets/logo-moresi-senza-zona-esclusione.png" />

            <center>Copyright by Moresi.com SA 2022 <br /><font style="text-align:center; font-size:9pt;">Powered by Microsoft Azure Services - <a href="/credits">Credits</a></font></center>
        </div>
    </div>
</template>

<script>
import constants from '../lib/constants'

export default {
  name: 'credits',
  methods: {
    login() {
      if (constants.authProvider) {
        window.location.href = `${constants.apiBaseUrl}/.auth/login/${constants.authProvider}?post_login_redirect_url=${encodeURIComponent(window.location.origin + '/host')}`
      } else {
        this.$router.push('credits')
      }
    },
    join() {
      this.$router.push('join')
    }
  }
}
</script>

<style>
div.main-option {
  border: 2px solid #ddd;
  border-radius: 10px;
  padding: 24px;
  max-width: 740px;
  margin: 24px auto;
}

.main-option h2 {
  margin: 0px 0px 12px 0px;
}

.main-option button {
  padding: 12px;
  border-radius: 8px;
  width: 300px;
  font-size: 16px;
}

.main-option input[type=text] {
  padding: 0px;
  margin: 12px;
  border-radius: 8px;
  height: 48px;
  width: 300px;
  font-size: 28px;
  text-align: center;
}

.footer
{
  margin-top: 20px;
  position: relative;
  bottom: 0;
  padding: 10px;
}

.footer img
{
  width: 20%;
}
    #nav {
        position: fixed;
        top: 15px;
        width: 100%;
        min-height: 50px;
        z-index: 1000;
        background-color: #fff;
    }
</style>
